<template>
    <div class="main-div">
        <header-gift-cert-purchased @closeDialog="closeDialog" />
        <main-gift-cert-purchased />
    </div>
</template>
<script setup lang="ts">
import { TrashIcon } from '@heroicons/vue/24/outline';
import { useConfirm } from 'primevue/useconfirm';
import { ModalNames } from '~/types/modals';
import HeaderGiftCertPurchased from './HeaderGiftCertPurchased.vue';
import MainGiftCertPurchased from './MainGiftCertPurchased.vue';
import { ref, provide } from 'vue';

const dialogRef = getDialogRef(ModalNames.GIFTCERT_PURCHASED);
const confirm = useConfirm();
const hasActionBeenTaken = ref(false);

provide('giftCertActionTaken', hasActionBeenTaken);

const closeDialog = () => {
    if (hasActionBeenTaken.value) {
        dialogRef.value.close();
        return;
    }
    confirm.require({
        group: 'confirmation',
        header: 'Close',
        message: 'Are you sure you want to leave this page before emailing or copying the gift certificate? You won\'t be able to find the code again without contacting support if so.',
        acceptLabel: 'Close',
        rejectLabel: 'Cancel',
        // @ts-ignore
        icon: TrashIcon,
        iconColor: '#e74341',
        iconBg: 'reject',
        iconBorderColor: 'reject',

        accept: () => {
            dialogRef.value.close();
        },
    });
};
</script>
<style lang="scss" scoped>
.main-div {
    @apply sm:max-w-lg sm:w-[544px] w-11/12 rounded-lg bg-white mx-auto h-auto overflow-y-auto sm:p-9 p-6 gap-9 flex flex-col;
}
</style>
